import { create } from 'zustand';
import { pendingInvitationsCheckManager } from '@/utils/pendingInvitationsCheck';

interface PendingInvitationsState {
  // State
  pendingCount: number;
  isChecking: boolean;
  lastCheckedAt: number | null;

  // Actions
  setPendingCount: (count: number) => void;
  setIsChecking: (checking: boolean) => void;

  // Lifecycle
  startMonitoring: () => void;
  stopMonitoring: () => void;
  forceCheck: () => void;
}

export const usePendingInvitationsStore = create<PendingInvitationsState>((set) => ({
  // Initial state
  pendingCount: 0,
  isChecking: false,
  lastCheckedAt: null,

  // Actions
  setPendingCount: (count: number) => {
    set({
      pendingCount: count,
      lastCheckedAt: Date.now(),
      isChecking: false,
    });
  },

  setIsChecking: (checking: boolean) => {
    set({ isChecking: checking });
  },

  // Lifecycle methods
  startMonitoring: () => {
    console.log('[PendingInvitationsStore] Starting monitoring');
    set({ isChecking: true });

    // Start the check manager with our callback
    pendingInvitationsCheckManager.start((count) => {
      set({
        pendingCount: count,
        lastCheckedAt: Date.now(),
        isChecking: false,
      });
    });
  },

  stopMonitoring: () => {
    console.log('[PendingInvitationsStore] Stopping monitoring');
    pendingInvitationsCheckManager.stop();
    set({
      pendingCount: 0,
      isChecking: false,
      lastCheckedAt: null,
    });
  },

  forceCheck: () => {
    console.log('[PendingInvitationsStore] Force check triggered');
    set({ isChecking: true });
    pendingInvitationsCheckManager.forceCheck();
  },
}));
